// extracted by css-extract-rspack-plugin
export default {"reviewsLink":"_ff667cc9"};